import {
  CreateTicketRequest,
  DeleteTicketRequest,
  GetTicketRequest,
  UpdateTicketRequest,
} from '../api/requests';
import type { UserStore } from '~/authentication/stores/user';
import type ApiClient from '~/common/services/ApiClient';
import { TicketRequest } from '../types';

export class TicketService {
  apiClient: ApiClient;
  userStore: UserStore;

  constructor(apiClient: ApiClient, userStore: UserStore) {
    this.apiClient = apiClient;
    this.userStore = userStore;
  }

  async create(userId: string, ticket: TicketRequest) {
    const accessToken = this.userStore.accessToken;
    const request = new CreateTicketRequest({
      token: accessToken,
      userId,
      ticket,
    });

    return this.apiClient.request(request);
  }

  async get(ticketId: string, params?: { include: string; source: string }) {
    const accessToken = this.userStore.accessToken;
    const request = new GetTicketRequest({
      token: accessToken,
      ticketId,
      params: { ...params },
    });

    return this.apiClient.request(request);
  }

  async update(ticketId: string, ticket: TicketRequest) {
    const accessToken = this.userStore.accessToken;
    const request = new UpdateTicketRequest({
      token: accessToken,
      ticketId,
      ticket,
    });

    return this.apiClient.request(request);
  }

  async delete(ticketId: string, params?: { source: string }) {
    const accessToken = this.userStore.accessToken;
    const request = new DeleteTicketRequest({
      token: accessToken,
      ticketId,
      params: { ...params },
    });

    return this.apiClient.request(request);
  }
}
